<template>
  <div
    :class="open ? 'faq open' : 'faq'"
    @click="$emit('toggleOpen', index)"
  >
    <div
      class="question"
      v-html="faq.question"
    />
    <!-- <div class="question">{{ faq.question.ru }}</div> -->
    <div
      class="answer"
      v-html="faq.answer"
    />
  </div>
</template>

<script>

export default {
	name: 'FAQ',
	props: ['faq', 'index', 'open'],
  emits: ['toggleOpen'],
}
</script>